import { createServerFn } from "@tanstack/react-start";
import { queryOptions } from "@tanstack/react-query";
import { archivedEpisodes, mergeEpisodes, parseFeed, PODCAST_FEED_URL } from "./podcast";

export const getPodcastEpisodes = createServerFn({ method: "GET" }).handler(async () => {
  try {
    const res = await fetch(PODCAST_FEED_URL, { headers: { "Accept-Language": "pl" } });
    if (!res.ok) return mergeEpisodes(archivedEpisodes);
    return mergeEpisodes(parseFeed(await res.text()), archivedEpisodes);
  } catch {
    return mergeEpisodes(archivedEpisodes);
  }
});

export const podcastEpisodesQuery = queryOptions({
  queryKey: ["podcast-episodes"],
  queryFn: () => getPodcastEpisodes(),
  staleTime: 60 * 60 * 1000,
});
